import { render, staticRenderFns } from "./Modify.vue?vue&type=template&id=781383df&"
import script from "./Modify.vue?vue&type=script&lang=ts&"
export * from "./Modify.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports